import React from 'react';

const Logo = ({ className = "w-6 h-6", vault = "dev" }) => {
  let filter = 'none';
  if (vault === 'dev') {
    filter = 'hue-rotate(-60deg)';
  } else if (vault === 'links') {
    filter = 'hue-rotate(-120deg) brightness(1.2)';
  } else if (vault === 'tools') {
    filter = 'hue-rotate(135deg) brightness(1.3)';
  } else if (vault === 'ai') {
    filter = 'none';
  }

  return (
    <img 
      src="/icons/icon128.png" 
      alt="Logo" 
      className={`${className} object-contain`}
      style={{ filter }}
    />
  );
};

export default Logo;
